<template>
    <div>
        <Row :gutter="24">
            <Col span="12" class="p-20">
                <Group title="印章信息">
                    <Cell title="印章编码：" :value="sealDetail.siCode"></Cell>
                    <Cell title="印章类型："><span v-dict:DictSocietySealsite_sealType="sealDetail.siSealType"></span></Cell>
                    <Cell title="印章名称：" :value="sealDetail.siName"></Cell>
                    <Cell title="印章规格：" :value="sealDetail.siSpec"></Cell>
                    <Cell title="章面材料："><span v-dict:DictSocietySealsite_sealMatType="sealDetail.siMatType"></span></Cell>
                    <Cell title="印油说明：" :value="sealDetail.siInkDesc"></Cell>
                    <Cell title="状态："><span v-dict:EntityGzwDzSeal_state="sealDetail.state"></span></Cell>
                    <Cell title="已选key类型："><span v-dict:DictSocietySealsite_sealDzType="sealDetail.dzDeviceType"></span>
                    </Cell>
                    <Cell title="电子公章价格：">{{sealDetail.dzDeviceType == '02'?'￥480':'￥380'}}</Cell>
                    <Cell title="参考图像："><img :src="sealDetail.dzImgImpressionOss|img_oss" width="58" height="58"
                                             v-show="sealDetail.dzImgImpressionOss"></Cell>
                </Group>
            </Col>
            <Col span="12" class="p-20">
                <Group title="使用单位信息">
                    <Cell title="使用单位编码：" :value="sealDetail.siOrgCode"></Cell>
                    <Cell title="社会统一信用代码：" :value="sealDetail.siOrgUscc"></Cell>
                    <Cell title="使用单位名称：" :value="sealDetail.siOrgName"></Cell>
                    <Cell title="使用单位名称（英文）：" :value="sealDetail.siOrgNameEng"></Cell>
                    <Cell title="使用单位名称（少数民族）：" :value="sealDetail.siOrgNameFolk"></Cell>
                    <Cell title="使用单位法人：" :value="sealDetail.siCrpName"></Cell>
                    <Cell title="使用单位法人身份证号码：" :value="sealDetail.siCrpCertNo"></Cell>
                    <Cell title="单位类型："><span v-dict:DictSocietySealsite_orgType="sealDetail.siOrgType"></span></Cell>
                    <Cell title="经办人：" :value="sealDetail.siOpName"></Cell>
                    <Cell title="经办人身份证号码：" :value="sealDetail.siOpCertNo"></Cell>
                </Group>
            </Col>
        </Row>
        <Row :gutter="24">
            <Col span="12" class="p-20">
                <Group title="制作单位信息">
                    <Cell title="制作单位编码：" :value="sealDetail.siMakerCode"></Cell>
                    <Cell title="制作单位名称：" :value="sealDetail.siMakerName"></Cell>
                    <Cell title="制作单位名称（英文）：" :value="sealDetail.siMakerNameEng"></Cell>
                    <Cell title="制作单位名称（少数民族）：" :value="sealDetail.siMakerNameFolk"></Cell>
                    <Cell title="承接日期：" :value="sealDetail.siDateAccept"></Cell>
                    <Cell title="制作日期：" :value="sealDetail.siDateMade"></Cell>
                </Group>
            </Col>
            <Col span="12" class="p-20">
                <Group title="备案公安单位信息">
                    <Cell title="备案单位编码：" :value="sealDetail.siSupervisorCode"></Cell>
                    <Cell title="备案单位名称：" :value="sealDetail.siSupervisorName"></Cell>
                    <Cell title="备案日期：" :value="sealDetail.siDatePermit"></Cell>
                    <Cell title="备案人：" :value="sealDetail.siSupervisorPersonName"></Cell>
                </Group>
            </Col>
        </Row>
        <Row :gutter="24">
            <Col span="12" class="p-20">
                <Group title="邮寄信息">
                    <Cell title="省市区："><span v-dist6nameZh="sealDetail.deliverDist6"></span></Cell>
                    <Cell title="收件人姓名：" :value="sealDetail.deliverPersonName"></Cell>
                    <Cell title="收件人电话：" :value="sealDetail.deliverPersonPhone"></Cell>
                    <Cell title="详细地址：" :value="sealDetail.deliverAddress"></Cell>
                    <Cell title="快递单号：" :value="sealDetail.deliverTrackingNo"
                          v-show="sealDetail.deliverTrackingNo"></Cell>
                </Group>
            </Col>
            <Col span="12" class="p-20">
                <Group title="支付信息">
                    <Cell title="支付方式："><span v-dict:DictStd_payType="sealDetail.payType"></span></Cell>
                    <Cell title="支付金额：" :value="sealDetail.settlePriceRetail"></Cell>
                    <Cell title="付款时间：" :value="sealDetail.dzPaidDate"></Cell>
                </Group>
            </Col>
        </Row>
    </div>
</template>

<script>
    import {dict} from '@tubo/tubo-base'

    export default {
        name: 'EsealInfo',
        props: {
            sealDetail: {
                required: true,
                type: Object
            }
        },
        data() {
            return {
                depositPayTypeList: [],
                company: {},
            }
        },
        created() {
            dict.dict('DictStd_payType').then(payload => this.depositPayTypeList = payload)
            // dict.dict('DictSocietySealsite_sealDzType').then(payload => this.sealDzTypeList = payload)
            this.company = this.$store.state.custom.user.company
            if (this.$route.query.id) {
                // this.$store.dispatch('clientGzwOrder/getSealImg',{id:this.$route.query.id}).then(payload => {
                //     this.sealImgUrl = _api.baseUrl + _api.client.gzwDz.sealImg + this.$route.query.id + '?token='  + store.state.user.user.token + '&version=' + new Date().getTime()
                // })
            }
        }
    }
</script>

<style>

</style>
